import { ca } from '@cian/analytics';

import { TTrackingParamsType } from '../../types/page/trackingParamsType';

export const trackShowPromoBanner = (siteType: TTrackingParamsType['siteType']) => {
  ca('teaser', {
    product: {
      name: 'rent_contract_landing_start_page',
    },
    page: {
      siteType,
    },
  });
};
